import React, { useState } from 'react';
import ProjectDetail from '../ProjectDetail/ProjectDetail';
import QueueAnim from 'rc-queue-anim';
import img1 from '../../images/1.jpg'
import img2 from '../../images/2.jpg'
import img3 from '../../images/3.png'
import img4 from '../../images/4.jpg'
import img5 from '../../images/5.jpg'
import img6 from '../../images/6.jpg'
const singleProject = [
    {
        id: 1,
        name: 'Take A Trip',
        description: 'This is a web application where you can select a place for your next tour. There are several tour packages. You can select a place then the packages that are available.',
        imgURL: img5,
        tech: ['React', 'MongoDB', 'Express.js', 'HTML', 'CSS', 'Bootstrap 4'],
        liveLink: 'https://take-a-trip-web-app.web.app/',
        sourceCode: 'https://github.com/Asif10H/Take_A_Trip',

    },
    {
        id: 2,
        name: 'Country Information',
        description: 'This application was built using React JS. The application displays all the name of countries, their capital city and their populations in the world.',
        imgURL: img1,
        tech: ['React', 'HTML', 'CSS', 'Bootstrap 4'],
        liveLink: 'https://country-information-react.netlify.app/',
        sourceCode: 'https://github.com/Asif10H/country-information',

    },
    {
        id: 3,
        name: 'Covid-19 Information',
        description: 'It is a API based APP for showing Global and Country wise Coronavirus Statistics.',
        imgURL: img2,
        tech: ['React', 'API', 'HTML', 'CSS', 'Bootstrap 4'],
        liveLink: 'https://covid-19-information.netlify.app/',
        sourceCode: 'https://github.com/Asif10H/covid-19-information',

    },
    {
        id: 4,
        name: 'Github User Search',
        description: 'A ReactJs web app for searching GitHub users.',
        imgURL: img3,
        tech: ['React', 'API', 'HTML', 'CSS', 'Bootstrap 4'],
        liveLink: 'https://search-github-profiles-10.netlify.app/',
        sourceCode: 'https://github.com/Asif10H/search-github-profiles',

    },
    {
        id: 5,
        name: 'Boighor Website',
        description: 'The user has to log in with google/email or create an account .Add new books and delete. React Router to navigate through pages.',
        imgURL: img4,
        tech: ['React', 'MongoDB', 'Express.js', 'HTML', 'CSS', 'Bootstrap 4'],
        liveLink: 'https://github.com/Asif10H/Boighor',
        sourceCode: 'https://github.com/Asif10H/Boighor',
    },
    {
        id: 6,
        name: 'Chakarian Riders',
        description: 'The user has to log in with google/email or create an account. For secure specific pages used the private route. User can give his source and destination where he/she want to go.',
        imgURL: img6,
        tech: ['React', 'HTML', 'CSS', 'Bootstrap 4'],
        liveLink: 'https://chakarian-riders.web.app/',
        sourceCode: 'https://github.com/Asif10H/Chakarian-Riders',
    }
]
const Projects = () => {
    return (
        <div id="cards_landscape_wrap-2">
            <div className="container ">
                <h2 className="text-center">My Works</h2>
                <QueueAnim type="scale">
                <div className="row">
                   
                        {
                            singleProject.map(project => <ProjectDetail project={project}></ProjectDetail>)
                        }
                  
                </div>
                </QueueAnim>
            </div>
        </div>

    );
};

export default Projects;